import { render, staticRenderFns } from "./NotifcationEventDialog.vue?vue&type=template&id=2200cca2&scoped=true&"
import script from "./NotifcationEventDialog.vue?vue&type=script&lang=js&"
export * from "./NotifcationEventDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotifcationEventDialog.vue?vue&type=style&index=0&id=2200cca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2200cca2",
  null
  
)

export default component.exports